const initialState = {
  isLoading: false,
  loadingMessage: '',
  isError: false,
  dxList: { listItems: [] },
  isMultiselect: false,
  multiselectItems: []
};

export default initialState;
